import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={s.root}>
      {/* Fondo decorativo */}
      <div style={s.bgOrb1} />
      <div style={s.bgOrb2} />
      <div style={s.bgOrb3} />

      <div style={s.card}>
        {/* Logo */}
        <div style={s.logoWrap}>
          <div style={s.logoBox}>
            <span style={s.logoText}>THE NEXUS</span>
          </div>
          <div style={s.logoDivider} />
          <div>
            <div style={s.appName}>Portal de Atención</div>
            <div style={s.appSub}>Powered by Sara IA</div>
          </div>
        </div>

        <h1 style={s.title}>Bienvenido</h1>
        <p style={s.subtitle}>Ingresa tus credenciales para continuar</p>

        <form onSubmit={handleSubmit} style={s.form}>
          <div style={s.field}>
            <label style={s.label}>Usuario</label>
            <div style={s.inputWrap}>
              <span style={s.inputIcon}>👤</span>
              <input
                style={s.input}
                type="text"
                value={username}
                onChange={e => setUsername(e.target.value)}
                placeholder="tu_usuario"
                autoComplete="username"
                required
              />
            </div>
          </div>

          <div style={s.field}>
            <label style={s.label}>Contraseña</label>
            <div style={s.inputWrap}>
              <span style={s.inputIcon}>🔒</span>
              <input
                style={s.input}
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                autoComplete="current-password"
                required
              />
            </div>
          </div>

          {error && (
            <div style={s.errorBox}>
              <span>⚠️</span> {error}
            </div>
          )}

          <button type="submit" style={{ ...s.btn, opacity: loading ? 0.7 : 1 }} disabled={loading}>
            {loading ? (
              <span style={s.btnLoader}>Verificando...</span>
            ) : (
              <>Ingresar <span style={s.btnArrow}>→</span></>
            )}
          </button>
        </form>

        <div style={s.footer}>
          Escuela de Audio y Sonido · Envigado, Colombia
        </div>
      </div>
    </div>
  );
}

const s = {
  root: {
    minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: '#0d0d14', position: 'relative', overflow: 'hidden', padding: 20,
  },
  bgOrb1: {
    position: 'absolute', width: 600, height: 600, borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(124,58,237,0.15) 0%, transparent 70%)',
    top: -200, left: -200, pointerEvents: 'none',
  },
  bgOrb2: {
    position: 'absolute', width: 500, height: 500, borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(236,72,153,0.1) 0%, transparent 70%)',
    bottom: -150, right: -150, pointerEvents: 'none',
  },
  bgOrb3: {
    position: 'absolute', width: 300, height: 300, borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(59,130,246,0.08) 0%, transparent 70%)',
    top: '40%', right: '20%', pointerEvents: 'none',
  },
  card: {
    background: 'rgba(255,255,255,0.03)', backdropFilter: 'blur(20px)',
    border: '1px solid rgba(255,255,255,0.08)', borderRadius: 24,
    padding: '40px 36px', width: '100%', maxWidth: 420, position: 'relative', zIndex: 1,
    boxShadow: '0 24px 80px rgba(0,0,0,0.4)',
  },
  logoWrap: { display: 'flex', alignItems: 'center', gap: 14, marginBottom: 32 },
  logoBox: {
    background: 'linear-gradient(135deg, #7c3aed, #ec4899)',
    borderRadius: 12, padding: '8px 14px',
    boxShadow: '0 4px 20px rgba(124,58,237,0.4)',
  },
  logoText: { fontWeight: 800, fontSize: 16, color: '#fff', letterSpacing: 2 },
  logoDivider: { width: 1, height: 32, background: 'rgba(255,255,255,0.1)' },
  appName: { fontWeight: 700, fontSize: 15, color: '#f1f5f9' },
  appSub: { fontSize: 11, color: '#64748b', marginTop: 2 },
  title: { fontSize: 28, fontWeight: 800, color: '#f8fafc', marginBottom: 8, letterSpacing: -0.5 },
  subtitle: { fontSize: 14, color: '#64748b', marginBottom: 28 },
  form: { display: 'flex', flexDirection: 'column', gap: 18 },
  field: { display: 'flex', flexDirection: 'column', gap: 8 },
  label: { fontSize: 12, fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 1 },
  inputWrap: {
    display: 'flex', alignItems: 'center', gap: 10,
    background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.09)',
    borderRadius: 12, padding: '12px 16px', transition: 'border-color 0.2s',
  },
  inputIcon: { fontSize: 15, opacity: 0.6 },
  input: {
    background: 'none', border: 'none', outline: 'none', color: '#f1f5f9',
    fontSize: 14, width: '100%', fontFamily: "'Plus Jakarta Sans', sans-serif",
  },
  errorBox: {
    background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.2)',
    borderRadius: 10, padding: '10px 14px', fontSize: 13, color: '#fca5a5',
    display: 'flex', alignItems: 'center', gap: 8,
  },
  btn: {
    background: 'linear-gradient(135deg, #7c3aed, #ec4899)',
    border: 'none', borderRadius: 12, padding: '14px 20px',
    color: '#fff', fontWeight: 700, fontSize: 15, cursor: 'pointer',
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
    boxShadow: '0 4px 20px rgba(124,58,237,0.35)',
    transition: 'opacity 0.2s, transform 0.1s',
    marginTop: 4,
  },
  btnArrow: { fontSize: 18 },
  btnLoader: { opacity: 0.8 },
  footer: { marginTop: 28, textAlign: 'center', fontSize: 12, color: '#334155' },
};
